export const SERVICES = [
  {
    id: 'civil',
    num: '01',
    title: 'Civil Work',
    tagline: 'Where every project begins.',
    desc: 'Foundations, structural concrete, masonry, and finishing &mdash; self-performed by long-tenured crews under in-house supervision. From private homes to hospitals and embassy compounds, we handle the structural backbone of every project we take on.',
    capabilities: [
      'Concrete work · foundations, columns, slabs',
      'Earthworks & excavation',
      'Drain-laying & site drainage',
      'Roads, retaining walls & infrastructure',
      'Water supply & treatment civil works',
      'Seismic retrofitting & heritage restoration',
    ],
    icon: 'M3 21h18M5 21V8l7-5 7 5v13M9 21v-6h6v6M9 12h.01M15 12h.01M19 12h.01M5 12h.01',
  },
  {
    id: 'mechanical',
    num: '02',
    title: 'Mechanical Work',
    tagline: 'HVAC, plant, and process systems.',
    desc: 'Mechanical heating, cooling, and ventilating of residential and commercial buildings. We install, replace, repair and alter machinery, fabricate ductwork in-house, and install roof flashing around the systems we deliver &mdash; all coordinated with our civil and electrical teams.',
    capabilities: [
      'HVAC heating, cooling & ventilation',
      'Sheet metal fabrication & ductwork',
      'Plant & machinery installation',
      'Roof flashing around installed systems',
      'Maintenance, repair & alteration of machinery',
      'Coordination with civil and electrical works',
    ],
    icon: 'M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z',
  },
  {
    id: 'electrical',
    num: '03',
    title: 'Electrical Work',
    tagline: 'Power, control, and resilience.',
    desc: 'Power supply and distribution, telecommunications, computing instrumentation, control systems and more. Our engineers deliver installation and control systems designed to meet customer specifications and the most up-to-date legislative standards &mdash; on budget, on spec.',
    capabilities: [
      'Electrical design & installation',
      'Power supply & distribution',
      'Electrical testing & inspection',
      'Control panel manufacture',
      'Supply of electrical equipment',
      'Maintenance, breakdown & shift cover',
    ],
    icon: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
  },
  {
    id: 'sanitary',
    num: '04',
    title: 'Sanitary Work',
    tagline: 'Plumbing, drainage and water.',
    desc: 'Sanitation for every residential, commercial and industrial building we deliver. Our experienced sanitary plumbers plan the layout of the system, install pipework for fixtures, and integrate stacks, vents and roof penetrations &mdash; with watertight detailing throughout.',
    capabilities: [
      'Sanitary system layout & design',
      'Sanitary stacks for multi-storey buildings',
      'Piped vents & roof penetrations',
      'Suspended pipework for fixtures',
      'Waste pipes for basins, sinks & toilets',
      'Greywater systems for toilet flushing',
    ],
    icon: 'M19 2L9 12l-7 0L12 22l7-2 0-7L19 2zM12 12l3.5 3.5',
  },
]
